<template>
    <div class="ui_priceInfo" v-if="isShow">
        <div class="priceInfoBox">
            <div class="infoBox">
                <div v-html="pricePlan" class="infos"></div>
            </div>
            <div class="bottom">
                <div class="priceBtn" @click="goFeedback" v-if="feedbackUrl">我要申诉</div>
                <div class="priceBtn" @click="goCodeText">更多细节</div>
            </div>
            <i class="icon iconfont iconshanchu1 close" @click="hide"></i>
        </div>
    </div>
</template>
<script>
import api from '@/utils/api';
import { urlEncode } from '@/utils/index';
import { getStorage, setStorage } from '@/utils/wxuser';
var config = {};
export default {
    props: ['datas'],
    data() {
        return {
            isShow: false,
            pricePlan: "",
            pricePlanTitle: "",
            feedbackUrl: "",
            type: "default"
        };
    },
    components: {},

    methods: {
        goFeedback() {
            this.goLink(this.feedbackUrl);
            /* uni.navigateToMiniProgram({
                appId: 'wxd947200f82267e58',
                path: 'pages/wjxqList/wjxqList?activityId=OXzIBVr',
                success(res) { }
            }); */
        },
        show() {
            this.isShow = true;
            if (this.type == 'props') {
                return false;
            }
            this.getfunctionControl();
        },
        hide() {
            this.isShow = false;
        },
        goCodeText() {
            let rule = {
                title: decodeURIComponent(this.pricePlanTitle),
                desc: this.pricePlan
            }
            setStorage('rule', rule)
            var obj = {
                type: 'storage'
            }
            this.$router.push({
                path: "/codeText",
                name: "codeText",
                query: obj,
            });
        },
        getfunctionControl() {
            var codes = ['pricePlan'];
            var self = this;
            var params = {
                appid: config.appid,
                codes: codes.join(','),
                componentAppid: config.componentAppid,
                hotelCode: config.hotelCode ? config.hotelCode : 0,
                hotelGroupCode: config.hotelGroupCode,
                clientType: 'wechat'
            };
            api.getMultiSysOptionCommonForHigh(params)
                .then(data => {
                    if (data.result == 1) {
                        data.retVal.forEach(function (n, i) {
                            if (n.code == 'pricePlan' && n.value) {
                                self.pricePlan = self.formatImg(n.value);
                                self.pricePlanTitle = n.overview || "官方最低价保证";
                            }
                        });
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        }
    },

    created() {
        config = getStorage("config");
        if (this.datas && this.datas.isOpenPricePlan == 'T') {
            this.type = "props";
            this.pricePlan = this.formatImg(this.datas.pricePlan);
            this.pricePlanTitle = this.datas.pricePlanTitle;
            this.feedbackUrl = this.datas.feedbackUrl;
        }
    },
    mounted() {

    },
    onUnload() { },
    computed: {}
};
</script>
<style lang="less">
@import url('~@/styles/base.less');
@import url('~@/styles/skin.less');
@import url('~@/styles/mixin.less');

.ui_priceInfo {
    width: 100vw;
    height: 100vh;
    background: rgba(255, 255, 255, 0.85);
    z-index: 99;
    position: fixed;
    left: 0;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    .priceInfoBox {
        padding: 20px;
        box-sizing: border-box;
        height: 485px;
        width: 315px;
        margin: 0 auto;
        background: #ffffff;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.3);
        border-radius: 10px;
        margin-top: 30px;
        position: relative;

        .infoBox {
            height: 400px;
            overflow-y: scroll;
            margin-bottom: 10px;

            .infos {
                img {
                    max-width: 100%;
                }
                overflow-x: hidden;
            }
        }

        .bottom {
            display: flex;
            align-items: center;
            justify-content: space-around;

            .priceBtn {
                width: 120px;
                height: 36px;
                line-height: 36px;
                text-align: center;
                font-size: 14px;
                color: @color-theme;
                border: 1px solid @color-theme;
                border-radius: 4px;

                &:nth-child(2) {
                    background-color: @color-theme;
                    color: #fff;
                }
            }
        }
    }

    .close {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        color: @color-theme;
        position: absolute;
        bottom: -50px;
        left: calc(~'(100vw - 96px) / 2');
        font-size: 32px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/priceInfo.vue